<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JRgNmz/tc-custom/9781459292543.jpg?1726519363573" alt="This image is the cover for the book Scandalous Proposal, The Little Season"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Scandalous Proposal, The Little Season
      </h1>
      <p class="bookDescription body article font2">
        <b>“With delightful characters and witty repartee” a couple pretends to be engaged as they solve a mystery in this Regency from a <i>New York Times </i>bestseller (<i>Publishers Weekly</i>).</b><br/><br/>Who would have thought a man could tire of being fawned over and flirted with? Ever since Cooper Townsend returned from France as a hero with a new title, he has been relentlessly pursued by every marriageable miss in London. Perhaps that’s why the unconventional Miss Daniella Foster is so appealing. She doesn’t simper or flatter. She only wants him to help unmask her sister’s blackmailer, and Coop has never been so intrigued. . . .<br/><br/>Let every other woman in London fight over His Lordship’s romantic attentions. Marriage is the last thing on Dany’s mind—at least until she samples his illicit kisses. Now, as a mutual enemy races to ruin Coop’s reputation and Dany’s family name, an engagement of convenience will spark an unlikely passion that might save them both.<br/><br/>“Kasey Michaels aims for the heart and never misses.” —<i>New York Times</i>–bestselling author Nora Roberts
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kasey Michaels
      </h2>
      
      <p class="authorDescription body article">USA TODAY bestselling author Kasey Michaels is the author of more than one hundred books. She has earned four starred reviews from Publishers Weekly, and has won an RT Book Reviews Career Achievement Award and several other commendations for her contemporary and historical novels. Kasey resides with her family in Pennsylvania. Readers may contact Kasey via her website at www.KaseyMichaels.com and find her on Facebook at http://www.facebook.com/AuthorKaseyMichaels.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e5eb975